export const footer = {
  en: {
    support: "SUPPORT",
    learn: "LEARN",
    workWithUs: "WORK WITH US",
    findMyOrder: "Find my order",
    shippingReturnsRefunds: "Shipping, Returns & Refunds",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsConditions: "Terms & Conditions",
    accessibility: "Accessibility",
    securePayments: "Secure Payments",
    privacyChoices: "Your Privacy Choices",
    ourStory: "Our Story",
    baerskinStories: "Baerskin Stories",
    veteransCharities: "Our Veterans Charities",
    wholesale: "Wholesale",
    becomeRetailer: "Become a Retailer",
    cookiePreferences: "Cookie Preferences",
    businessHours: "Monday to Friday 9-5(EST)",
    // Copyright line. {store} = store name; {years} = the year range.
    copyright: "© {years} {store}. All rights reserved.",
  },
  de: {
    support: "SERVICE",
    learn: "ENTDECKEN",
    workWithUs: "ARBEITE MIT UNS",
    findMyOrder: "Bestellung finden",
    shippingReturnsRefunds: "Versand, Rückgabe & Erstattung",
    contactUs: "Kontakt",
    privacyPolicy: "Datenschutzerklärung",
    termsConditions: "AGB",
    accessibility: "Barrierefreiheit",
    securePayments: "Sichere Zahlung",
    privacyChoices: "Deine Datenschutz-Optionen",
    ourStory: "Unsere Geschichte",
    baerskinStories: "Baerskin Stories",
    veteransCharities: "Unsere Veteranen-Organisationen",
    wholesale: "Großhandel",
    becomeRetailer: "Händler werden",
    cookiePreferences: "Cookie-Einstellungen",
    businessHours: "Montag bis Freitag, 9–17 Uhr (EST)",
    copyright: "© {years} {store}. Alle Rechte vorbehalten.",
  },
} as const
